import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { getStoreById } from "../../reducers/store";

import { primary_s26_l96 } from "../../shared/lib/colors";

import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import Home from "./Home";
import PreviewBackArrow from "../../components/back-arrow/back-arrow";

import "../../styles/style.scss";
import "../../styles/style.less";

moment.locale("it");

class App extends Component {
  state = {
    showBackArrow: true,
  }
  
  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.id) {
      this.props.getStoreById(this.props.id);
    } else {
      const { storeId } = this.props.match.params;
      this.props.getStoreById(storeId);
      // console.log(storeId);
    }
    if (window.location.pathname.includes('editor') || window.innerWidth < 600) {
      this.setState({
        showBackArrow: false
      })
    }
  }
  renderBackgroundVersion = (uiVariantBackground) => {
    switch (uiVariantBackground) {
      case "1":
        return primary_s26_l96(this.props.primaryColor);
      case "2":
        return "#f6f6f6";
      case "3":
        return "#fff";
      // default:
      //   return primary_s26_l96(this.props.primaryColor);
      default:
        return uiVariantBackground;
    }
  };

  render() {
    const isCheckout = false;
    console.log(window)
    return (
      <div className={isCheckout ? "is-checkout" : "is-not-checkout"}>
        {this.state.showBackArrow && <PreviewBackArrow />}
        <div
          className="global-wrapper"
          style={{
            backgroundColor: this.renderBackgroundVersion(
              this.props.uiVariantBackground
            ),
          }}
        >
          <Header isCheckout={isCheckout} />
          <Home />
          <div className="push" />
        </div>
        <Footer isCheckout={isCheckout} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    siteName: state.store.singleStore.siteName,
    favicon: state.store.singleStore.faviconImage,
    primaryColor: state.store.singleStore.brandColor,
    uiVariantBackground: state.store.singleStore.background,
  };
};

export default connect(mapStateToProps, { getStoreById })(App);
